var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3361 5.53049H29.0217C28.3996 5.53049 27.8953 6.03467 27.8953 6.6569V9.61817H12.6673C12.6741 9.54382 12.6788 9.46888 12.6788 9.39288V8.6472C12.6788 7.28078 11.5671 6.16909 10.2007 6.16909H4.98416C4.90816 6.16909 4.83322 6.17374 4.75887 6.1805V1.675C4.75887 1.05277 4.25454 0.548584 3.63246 0.548584H1.12641C0.504333 0.548584 0 1.05277 0 1.675V20.3251C0 20.9473 0.504333 21.4515 1.12641 21.4515H3.63246C4.25454 21.4515 4.75887 20.9473 4.75887 20.3251V18.0664H27.8951V20.3251C27.8951 20.9473 28.3994 21.4515 29.0215 21.4515H31.3359C31.958 21.4515 32.4623 20.9473 32.4623 20.3251V6.6569C32.4625 6.03482 31.9582 5.53049 31.3361 5.53049ZM27.8951 13.578H4.75887V11.871H4.98416H10.2007H27.8951V13.578Z",
    fill: "#6E6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.d09d26c7f04a960f805bbb6fa00f2dc4.svg";
export { ForwardRef as ReactComponent };